import { useDispatch, useSelector } from 'react-redux';
import { TiptapSelectionPopupKind } from './tiptapSelectionPopupTypes';
import { getCurrentlyEditingId } from '../../../element/selection/currentlyEditingSelector';
import { useActiveTiptapEditorCallback } from '../store/tiptapEditorStoreHooks';
import { getTiptapPopupPosition } from '../utils/tiptapPopupUtils';
import { openTiptapSelectionPopup } from './tiptapSelectionPopupActions';

export const useOpenTiptapSelectionPopup = (kind: TiptapSelectionPopupKind): (() => void) => {
    const dispatch = useDispatch();
    const currentlyEditingId = useSelector(getCurrentlyEditingId);

    return useActiveTiptapEditorCallback(
        (editor) => {
            if (!editor) return;

            const { from, to } = editor.state.selection;
            const range = { from, to };
            const position = getTiptapPopupPosition(editor, range);

            dispatch(
                openTiptapSelectionPopup({
                    kind,
                    position,
                    range,
                    editingElementId: currentlyEditingId,
                }),
            );
        },
        [dispatch, kind, currentlyEditingId],
    );
};
